export default {
  stepper: {
    description: 'Onboarding restaurant',
    steps: {
      confirm_email: 'Confirmați adresa de email',
      add_store_details: 'Adăugați detaliile magazinului',
      add_personal_details: 'Adăugați informațiile personale',
      add_bank_details: 'Adăugați datele bancare pentru plăți',
      add_tax_details: 'Afacerea dvs. este înregistrată în scop de TVA?',
      upload_business_doc: 'Document doveditor al afacerii',
      upload_personal_doc: 'Document de identitate',
      confirm_details: 'Primiți plăți',
    },
  },
  completed: {
    title: 'Integrare finalizată',
    description:
      'Integrarea dvs. este finalizată. Puteți adăuga documente aici oricând, de exemplu un act de identitate al unui nou partener sau unul reînnoit.',
  },
  toasts: {
    failed_to_skip_verification_step: 'Pasul de verificare nu a putut fi omis. Vă rugăm să încercați din nou',
  },
};
